import { Control, UseFormSetValue } from 'react-hook-form';
import { TextInputField } from '@brighte/form-components';
import { RepaymentAccountType } from '@brighte/validation';
import { Columns } from '@spark-web/columns';
import { LABELS } from '@utils';
import BsbInput from './BsbInput';

type Props = {
  control: Control<RepaymentAccountType>;
  setValue: UseFormSetValue<RepaymentAccountType>;
};

function DirectDebit({ control, setValue }: Props) {
  const { BANK_ACCOUNT_NAME, ACCOUNT_NUMBER } = LABELS;

  const handleAccountNumberFocus = () => {
    setValue('payment.directDebit.accountNumber', '');
    setValue('payment.methodId', '');
  };
  const handleOnChange = () => {
    setValue('payment.methodId', '');
  };

  return (
    <>
      <TextInputField
        control={control}
        name="payment.directDebit.accountName"
        label={BANK_ACCOUNT_NAME}
        onChange={handleOnChange}
      />
      <Columns gap="xxlarge" collapseBelow="tablet">
        <BsbInput control={control} />
        <TextInputField
          control={control}
          name="payment.directDebit.accountNumber"
          label={ACCOUNT_NUMBER}
          autoComplete="off"
          onFocus={handleAccountNumberFocus}
        />
      </Columns>
    </>
  );
}

export default DirectDebit;
